import * as apiFactory from "./ApiFactory";

import type { CheckPointData, CheckPointUpdateBody, ScorePointData } from "@/models/Point";

export async function getCheckPoints(
  clientName: string,
  brand: string,
  caseReference: string,
  name: string,
): Promise<CheckPointData[]> {
  const client = await apiFactory.WithBearer();
  return await client.getWithPollingSignal<CheckPointData[]>([
    "/api/points/checkpoint",
    clientName,
    brand,
    caseReference,
    name,
  ]);
}

export async function getScorePoints(
  clientName: string,
  brand: string,
  caseReference: string,
  name: string,
): Promise<ScorePointData[]> {
  const client = await apiFactory.WithBearer();
  return await client.getWithPollingSignal<ScorePointData[]>([
    "/api/points/scorepoint",
    clientName,
    brand,
    caseReference,
    name,
  ]);
}

export async function updateCheckPoint(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string | undefined,
  reference: string,
  body: CheckPointUpdateBody,
) {
  const client = await apiFactory.WithBearer();

  const urlParts = ["/api/points", clientName, brand, caseReference];
  if (fileReference != null) urlParts.push(fileReference);
  urlParts.push(reference);

  return await client.put<CheckPointUpdateBody, never>(urlParts, body);
}
